import React from 'react';
import { useAnnouncementStore } from '../stores/announcementStore';

// ponytail: AnnouncementContext thin facade mapping to announcementStore.
export const useAnnouncement = () => {
  return useAnnouncementStore();
};

export const AnnouncementProvider = ({ children }) => {
  return <>{children}</>;
};

export default useAnnouncementStore;
